import { usePhotoFilenameExampleQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { Spin } from 'antd'
import { useRefetchWithParent } from '../../../../../hooks/useRefetchWithParent'
import { PhotoFilename } from '../../../PhotoFilenameContext/types'
import { usePhotoFilenamesContext } from '../../../PhotoFilenameContext'
import { useProjectContext } from 'context/ProjectContext'

const Example: React.FC<PhotoFilename> = ({ id: classTypeId }) => {
  const { projectId } = useProjectContext()
  const { loading: parentLoading } = usePhotoFilenamesContext()
  const { data, loading, refetch } = usePhotoFilenameExampleQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { classTypeId, projectId } },
  })
  useRefetchWithParent({ refetch, parentLoading })
  return (
    <Spin spinning={loading ?? false} size="small">
      {data?.photoFilenameExample}
    </Spin>
  )
}

export default Example
